import React, { Component, lazy } from 'react';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import LazyBoundary from '@com/LazyBoundary';
import { MEETING_SCENE_SOURCE } from '@src/page/toc/common/meeting-room-manager/message_const';
import stylesMobile from '../../style-mobile.less';
import stylesPC from '../../style-pc.less';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import i18n from '@i18next/i18n';
import FullscreenHandler from '@src/utils/fullscreen/fullscreen-handler';
import { IRemoteControlManager } from '@src/slide/application/service/remote-control-manager/core/interface';
import RemoteControlPcWrapper from '@src/page/toc/common/meeting-room-manager/components/mobile-remote-control/wrapper/pc';
const SlidePlayer = lazy(() => import(/* webpackChunkName: "lazySlidePlayer" */ '@src/framework/meeting-room-slidePlayer/SlidePlayerv2'));

const styles = browser.isMobile ? stylesMobile : stylesPC;

interface IRemoteControlPlayProps {
    currentPage: number;
    onPlayEnd?: (pageIndex?: number) => any;
    remoteControlManager: IRemoteControlManager;
}

export default class MobileRemoteControlPCContainer extends Component<IRemoteControlPlayProps, {}> {
    private snackbar?: ReturnType<typeof Snackbar.show>;
    private timer?: ReturnType<typeof setTimeout>;
    public constructor(props: IRemoteControlPlayProps) {
        super(props);
    }

    public componentDidMount(): void {
        const { isAutoFullScreenSuccess } = this.props.remoteControlManager;
        // 如果自动全屏失败，就添加提示
        if (!isAutoFullScreenSuccess) {
            this.snackbar = Snackbar.show({
                message: i18n.t('因浏览器限制无法自动全屏，可点击按钮切换'),
                type: 'info',
                action: i18n.t('全屏'),
                onClickAction: () => {
                    FullscreenHandler.getInstance().requestFullscreen(document.body);
                },
                // 设置为 autoClose 的话会被其他的 snackbar 替换掉，所以自己管理关闭
                autoClose: false,
                closable: true,
            });
            this.timer = setTimeout(() => {
                this.snackbar?.close();
            }, 5000);
        }
    }

    public componentWillUnmount(): void {
        this.snackbar?.close();
        this.timer && clearTimeout(this.timer);
    }

    public render(): JSX.Element {
        return (
            <RemoteControlPcWrapper
                remoteControlManager={this.props.remoteControlManager}
                onPlayEnd={this.props.onPlayEnd}
            >
                <div className={styles['manager-wrapper']}>
                    <div className={'wrapperStyle'} id="playerContainer" style={{ width: '100%' }}>
                        <LazyBoundary>
                            <SlidePlayer inEditor sceneSource={MEETING_SCENE_SOURCE.RemoteControl} />
                        </LazyBoundary>
                    </div>
                </div>
            </RemoteControlPcWrapper>
        );
    }
}
